export const getPageHref = (
    page: string,
    params?: Record<string, string>,
    showExperiments = true,
) => {
    const {searchParams} = new URL(window.location.href);
    const experiments = searchParams.get('experiments');
    const newUrl = new URL(page, window.location.origin);

    showExperiments && experiments && newUrl.searchParams.set('experiments', experiments);

    for (const param in params) {
        newUrl.searchParams.set(param, params[param] || '');
    }

    return newUrl.href;
};
